import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import ComponentState from './states'
import { State } from '@/store/store'

const components: Module<ComponentState, State> = {
  state: new ComponentState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default components
